import exclusiveNeoApi from 'shared_js/api/exclusiveApi/exclusiveNeoApi';
import exclusiveMitraWalletApi from 'shared_js/api/exclusiveApi/exclusiveMitraWalletApi';
import publicPaymentDomainApi from 'shared_js/api/publicApi/publicPaymentDomainApi';
import isMwebUrl from 'shared_js/helpers/urlHelper/isMwebUrl';

const WALLET_VJI_CONFIG_KEY = 'mitra-wallet-vji-config';
const WALLET_VJI_TOGGLE_KEY = 'mitra-wallet-vji-enabled';
const WALLET_VJI_PRODUCT_TYPE = 'wallet-vji';

const initialState = {
  isWalletVjiWhitelisted: false,
  walletVjiFullyRolledOut: false,
  walletVjiToggleEnabled: false,
  walletVjiBound: false,
  b2b2cAccessToken: '',
};

const getters = {
  isWalletVjiWhitelisted(state) {
    return state.isWalletVjiWhitelisted;
  },
  walletVjiFullyRolledOut(state) {
    return state.walletVjiFullyRolledOut;
  },
  walletVjiToggleEnabled(state) {
    return state.walletVjiToggleEnabled;
  },
  isWalletVjiEnabled(state) {
    if (!state.walletVjiToggleEnabled) return false;
    return state.walletVjiFullyRolledOut || state.isWalletVjiWhitelisted;
  },
  isWalletVjiBound(state) {
    return state.walletVjiBound === true;
  },
  isWalletVjiEnabledAndUnbound(_state, _getters, _rootState, rootGetters) {
    return rootGetters.isWalletVjiEnabled && !rootGetters.isWalletVjiBound;
  },
  b2b2cAccessToken(state) {
    return state.b2b2cAccessToken;
  },
};

const actions = {
  async initWalletVji({ dispatch, state }) {
    await dispatch('fetchWalletVjiToggle');
    if (!state.walletVjiToggleEnabled) return;
    await Promise.allSettled([
      dispatch('fetchWalletVjiWhitelistStatus'),
      dispatch('fetchWalletVjiConfig'),
      dispatch('generateWalletVjiB2b2cToken'),
    ]);
  },
  async fetchWalletVjiToggle({ commit }) {
    try {
      const platform = isMwebUrl()
        ? 'bl_app_pwa_mitra_android'
        : 'bl_mobile_web';
      const { data } = await exclusiveNeoApi.retrieveTogglesStatus(
        [WALLET_VJI_TOGGLE_KEY],
        platform,
      );
      const toggle =
        data?.find?.(item => item.id === WALLET_VJI_TOGGLE_KEY) ?? data?.[0];
      commit('setWalletVjiToggleEnabled', toggle?.active ?? false);
    } catch (e) {
      commit('setWalletVjiToggleEnabled', false);
    }
  },
  async fetchWalletVjiWhitelistStatus({ commit }) {
    try {
      const response = await exclusiveMitraWalletApi.retrieveWhitelist({
        productType: WALLET_VJI_PRODUCT_TYPE,
      });
      commit('setWalletVjiWhitelisted', response.data.whitelisted);
    } catch (e) {
      // ignore for now
    }
  },
  async fetchWalletVjiConfig({ commit }) {
    try {
      const { data } = await exclusiveNeoApi.retrieveNeoConfig([
        WALLET_VJI_CONFIG_KEY,
      ]);
      commit(
        'setWalletVjiFullyRolledOut',
        data?.[0]?.data?.['wallet-vji-fully-rolled-out'] || false,
      );
    } catch (e) {
      // ignore for now
    }
  },
  // TODO create logic to cache the token so that it doesn't need to be called on every page load
  async generateWalletVjiB2b2cToken({ commit }) {
    try {
      const response = await publicPaymentDomainApi.generateWalletVjiB2b2cToken();
      const accessToken =
        response?.data?.access_token ?? response?.access_token ?? '';
      commit('setWalletVjiB2b2cAccessToken', accessToken);
    } catch (e) {
      // ignore for now
    }
  },
};

const mutations = {
  setWalletVjiWhitelisted(state, isWhitelisted) {
    state.isWalletVjiWhitelisted = isWhitelisted;
  },
  setWalletVjiFullyRolledOut(state, isFullyRolledOut) {
    state.walletVjiFullyRolledOut = isFullyRolledOut;
  },
  setWalletVjiToggleEnabled(state, isEnabled) {
    state.walletVjiToggleEnabled = isEnabled;
  },
  setWalletVjiBound(state, isBound) {
    state.walletVjiBound = isBound;
  },
  setWalletVjiB2b2cAccessToken(state, b2b2cAccessToken) {
    state.b2b2cAccessToken = b2b2cAccessToken;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
